import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";

import "antd/dist/antd.css";
import "./css/style.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";

const safeGetItem = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn(`localStorage.getItem failed for key="${key}"`, e);
    return null;
  }
};

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem failed for key="${key}"`, e);
    return false;
  }
};

async function performMaintenanceIfNeeded() {
  const APP_VERSION = '1.0.1';
  const VERSION_KEY = 'nocap_version';

  try {
    let storedVersion = safeGetItem(VERSION_KEY);
    
    if (storedVersion === null) {
      try {
        storedVersion = sessionStorage.getItem(VERSION_KEY);
      } catch (e) {
        storedVersion = null;
      }
    }

    if (storedVersion === APP_VERSION) {
      console.log(`✅ App version ${APP_VERSION} - no maintenance needed`);
      return;
    }

    console.log(`🔧 Performing one-time maintenance (${storedVersion || 'first-time'} → ${APP_VERSION})`);

    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (let registration of registrations) {
        await registration.unregister();
      }
      if (registrations.length > 0) {
        console.log('✅ Cleared Service Workers');
      }
    }

    if ('caches' in window) {
      const cacheNames = await caches.keys();
      for (let cacheName of cacheNames) {
        await caches.delete(cacheName);
      }
      if (cacheNames.length > 0) {
        console.log('✅ Cleared caches');
      }
    }

    let saved = safeSetItem(VERSION_KEY, APP_VERSION);
    
    if (saved) {
      console.log(`✅ Maintenance complete - version ${APP_VERSION} saved to localStorage`);
    } else {
      try {
        sessionStorage.setItem(VERSION_KEY, APP_VERSION);
        console.log(`✅ Maintenance complete - version ${APP_VERSION} saved to sessionStorage (localStorage blocked)`);
      } catch (e) {
        console.warn(`⚠️ Maintenance complete but could not save version (all storage blocked - cleanup will run again)`);
      }
    }

  } catch (error) {
    console.warn('⚠️ Maintenance failed (non-critical):', error);
  }
}

performMaintenanceIfNeeded().then(() => {
  ReactGA.initialize("UA-233372313-1");

  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
  );
});

serviceWorker.unregister();